/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListMessagesQueryResponse, IncidentInvestigationControllerListMessagesPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerListMessages";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerListMessages } from "../../clients/incident-agentService/incidentInvestigationControllerListMessages";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerListMessagesQueryKey = (id: IncidentInvestigationControllerListMessagesPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/messages',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerListMessagesQueryKey = ReturnType<typeof incidentInvestigationControllerListMessagesQueryKey>;
export function incidentInvestigationControllerListMessagesQueryOptions(id: IncidentInvestigationControllerListMessagesPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerListMessagesQueryKey(id);
  return queryOptions<IncidentInvestigationControllerListMessagesQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerListMessagesQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerListMessages(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/messages}
 */
export function useIncidentInvestigationControllerListMessages<TData = IncidentInvestigationControllerListMessagesQueryResponse, TQueryData = IncidentInvestigationControllerListMessagesQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerListMessagesQueryKey>(id: IncidentInvestigationControllerListMessagesPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerListMessagesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerListMessagesQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerListMessagesQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}